import KformComponent from '../kform-component';

export default class WfHistoComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentWfHisto | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.displayHistoryBtn = settings?.displayHistoryBtn ?? true;
	}
}
